const initialState = {
  conferences: null,
  adminconferences: null,
  currentProfile: null,
  currentApplication: null,
  currentApplications: null,
};

export default initialState;
